<div class="modal solid open progress-modal">

  <div class="progress-wizard-wrapper">
    <div class="progress-wizard-container">
      @if (showCloseButton) {
        <div (click)="cancel()" class="close cancel"></div>
      }
      <div class="side-progress-bar">
        <div class="progress-steps">
          <div class="progress-track" style="height: {{progressTrackHeight}}"></div>
          @for (step of progressSteps; track step) {
            <div class="progress-step" [ngClass]="{'step-active': step.index === currentStepIndex}">
              <div class="progress-step-number">{{step.index}}</div>
              <div class="progress-step-number-background"></div>
              <div class="progress-step-label">{{step.label}}</div>
            </div>
          }
        </div>
      </div>
      <div>
        <div class="center-content-container">
          <div class="center-content">
            <div class="header-title-container" style="align-items: center;">
              <div class="header-title-container" style="display: flex; flex-direction: row; gap: var(--gapSmall);align-items: center;">
                @if (currentStepIndex === 0) {
                  <div class="header-title-image header-icon icon-integrations"></div>
                }
                @if (currentStepIndex === 1) {
                  <div class="header-title-image header-icon icon-Edit"></div>
                }
                @if (currentStepIndex === 2) {
                  <div class="header-title-image header-icon icon-RotatePassword-RBAC"></div>
                }
                <div class="header-title">{{title}}</div>
              </div>
            </div>
            <div name="form" class="step-content-form">
              @if (isLoading && currentStepIndex !== 2) {
                <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
              }
              <div class="sub-title-container">
                <div class="header-title header-subtitle">{{subtitle}}</div>
              </div>
              <div class="step-content-wrapper">
                <div class="progress-modal-content">
                  @if (currentStepIndex === 0) {
                    <div>
                      <lib-form-field-container [title]="'Integration Name'" [label]="errMap['name'] ? 'INVALID' : 'REQUIRED'">
                        <input
                          class="form-field-input"
                          placeholder="Name this SCIM Integration"
                          [ngClass]="{error: errMap['name'] || errMap['nameRequired']}"
                          [(ngModel)]="formData.name"
                          autofocus
                          #nameFieldInput
                          />
                      </lib-form-field-container>
                    </div>
                  }

                  @if (formData.id && currentStepIndex === 1) {
                    <div class="scim-mapping-config-container">
                      <lib-update-scim-mapping-config
                        [integrationId]="formData.id"
                        [showUpdateMappingConfig]="(!isLoading && currentStepIndex === 1)"
                        [showHeader]="false"
                        [showApply]="false"
                        [save]="saveSubject"
                        (wasUpdated)="mappingConfigUpdateHandler($event)"
                      ></lib-update-scim-mapping-config>
                    </div>
                  }

                  @if (currentStepIndex === 2) {
                    <div class="token-container" [ngClass]="{generated: displayDoneButton}">
                      <lib-form-field-container [showHeader]="false">
                        <lib-scim-integration-url-copy
                          [baseUrl]="svc.integrationClientUrl"
                          [integrationKey]="formData.integrationKey"
                        ></lib-scim-integration-url-copy>
                        <lib-scim-integration-auth
                          [integrationId]="formData.id"
                          (authUpdatedEmitter)="onGenerateAuthToken($event)"
                          >
                        </lib-scim-integration-auth>
                      </lib-form-field-container>
                    </div>
                  }

                </div>
              </div>
              <div class="buttons-container">
                <div></div>
                @if (currentStepIndex !== 2 || displayDoneButton) {
                  <button name="action" type="submit" class="btn-primary" (click)="nextStep()" [disabled]="nextButtonDisabled">
                    {{nextButtonLabel}}
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

